import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getLabel } from "../../../hooks/use-labels";

import HexLoader from "../../../components/HexLoader";
import HexInfiniteScroll from "../../../components/HexInfiniteScroll";

import {
  GetLocationState,
  GetParam,
  findData,
} from "../../../utils/common-utils";

import SupplierProductViewHeader from "./SupplierProductViewHeader";
import ProductCardsList from "../MaterialWiseProducts/ProductCardsList";
import { fetchSupplierProducts } from "../api-handler";
import { defaultProductFilters } from "./product-view-utils";

import { getProductFilters } from "../supplier-detail-utils";
import EmptyListBox from "../../../components/EmptyListBox";
import ResizeWrapper from "../../../components/ResizeWrapper";
import { hasAccessoryOptions } from "../../Home/Components/SupplierFilters/filter-utils";
import "./style.css";

const SupplierProductView = () => {
  const { link, menuFilter: stateMenuFilter } = GetLocationState();
  const { containerMaterials, containerOptions } = useSelector(
    (state) => state.publicAPIs
  );

  const [products, setProducts] = useState([]);
  const [last, setLast] = useState(false);

  const parameters = GetParam([
    "supplierId",
    "fuelTypeId",
    "containerOptionId",
    "containerMaterialId",
  ]);

  const { supplierId, fuelTypeId, containerOptionId, containerMaterialId } =
    parameters;

  const [loading, setLoading] = useState(true);

  const hasAccessories = hasAccessoryOptions(containerOptions, [
    +containerOptionId,
  ]);

  const [productFilters, setProductFilters] = useState({
    search: "",
    menuFilter: {
      containerOptionId: [+containerOptionId],
      containerMaterialId: +containerMaterialId,

      ...(fuelTypeId && { fuelTypeId: [+fuelTypeId] }),
      ...(supplierId && { supplierId: +supplierId }),

      ...defaultProductFilters,
      ...getProductFilters(stateMenuFilter),
    },
  });

  const [pagination, setPagination] = useState({
    size: 20,
    page: 0,
    last: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getProducts(productFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productFilters, pagination]);

  const getProducts = (filterDetails) => {
    const { menuFilter, search } = filterDetails;
    const requestParams = {
      active: true,
      sort: "id,ASC",
      ...pagination,
      ...getProductFilters(stateMenuFilter),
      ...menuFilter,
      containerOptionId: [+containerOptionId],
      containerMaterialId: +containerMaterialId,
      ...(search && { name: search }),

      ...(!hasAccessories && fuelTypeId && { fuelTypeId: [+fuelTypeId] }),
      ...(supplierId && { supplierId: +supplierId }),
      ...(hasAccessories && { minVolume: 1 }),
    };

    fetchSupplierProducts(requestParams)
      .then(({ data }) => {
        setProducts(data.content);
        setLast(data.last);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const handleScroll = () => {
    setPagination((prev) => ({ ...prev, size: prev.size + 10 }));
  };

  const updateFilter = (filterDetails) => {
    setLoading(true);

    filterDetails.menuFilter = {
      ...filterDetails.menuFilter,
      containerOptionId: [+containerOptionId],
    };
    setProductFilters({
      ...filterDetails,
    });
  };

  const getMaterial = () => {
    return findData(containerMaterials, "id", +containerMaterialId);
  };

  const getContainerOption = () => {
    return (
      containerOptions.length &&
      findData(containerOptions, "id", +containerOptionId)
    );
  };

  return (
    <ResizeWrapper
      render={(resizeWidth) => (
        <div className="product-view">
          <SupplierProductViewHeader
            link={link}
            filters={productFilters}
            updateFilter={updateFilter}
            pageTitle={supplierId ? getMaterial().label : "Search results"}
            resizeWidth={resizeWidth}
          />

          {loading ? (
            <HexLoader />
          ) : products.length > 0 ? (
            <HexInfiniteScroll
              data={products}
              onScroll={handleScroll}
              hasMore={!last}
              height={950}
            >
              <div className="material-products-list">
                <ProductCardsList
                  products={products}
                  material={getMaterial()}
                  containerOption={getContainerOption()}
                  showDistance={stateMenuFilter && stateMenuFilter.latitude}
                  xs={resizeWidth < 376 ? 24 : 12}
                />
              </div>
            </HexInfiniteScroll>
          ) : (
            <div className="empty-product-filter">
              <EmptyListBox
                title={getLabel("noResultsLabel")}
                imageSrc={"/assets/icons/no-search-result.png"}
              />
            </div>
          )}
        </div>
      )}
    />
  );
};

export default SupplierProductView;
